import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_mst_coupon_line_scan_event_attachment_RowInterface {
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  activation_pin: fromDatatype.VarcharDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  assignment_date: fromDatatype.TimestampTzDatatypeInterface;
  assignment_status: fromDatatype.VarcharDatatypeInterface;
  cancellation_status: fromDatatype.VarcharDatatypeInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  conditional_filter_json: fromDatatype.JsonDatatypeInterface;
  coupon_type: fromDatatype.VarcharDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  event_code: fromDatatype.VarcharDatatypeInterface;
  guid: fromDatatype.GuidDataFieldInterface;
  guid_file: fromDatatype.GuidDataFieldInterface;
  hdr_guid: fromDatatype.GuidDataFieldInterface;
  line_guid: fromDatatype.GuidDataFieldInterface;
  membership_hdr_guid: fromDatatype.GuidDataFieldInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  namespace: fromDatatype.NamespaceDataFieldInterface;
  obj_action: fromDatatype.VarcharDatatypeInterface;
  payment_logic_json: fromDatatype.JsonDatatypeInterface;
  pricing_bundle_json: fromDatatype.JsonDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  redeemable_date_from: fromDatatype.TimestampTzDatatypeInterface;
  redeemable_date_to: fromDatatype.TimestampTzDatatypeInterface;
  redemption_status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  scan_event_guid: fromDatatype.GuidDataFieldInterface;
  serial_number: fromDatatype.VarcharDatatypeInterface;
  softpin: fromDatatype.VarcharDatatypeInterface;
  source: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  subject_guid: fromDatatype.GuidDataFieldInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  url_key: fromDatatype.VarcharDatatypeInterface;
  usage_json: fromDatatype.JsonDatatypeInterface;
  validity_status: fromDatatype.VarcharDatatypeInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_fi_mst_coupon_line_scan_event_attachment_RowClass
  implements bl_fi_mst_coupon_line_scan_event_attachment_RowInterface {
    acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  activation_pin: fromDatatype.VarcharDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  assignment_date: fromDatatype.TimestampTzDatatypeInterface;
  assignment_status: fromDatatype.VarcharDatatypeInterface;
  cancellation_status: fromDatatype.VarcharDatatypeInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  conditional_filter_json: fromDatatype.JsonDatatypeInterface;
  coupon_type: fromDatatype.VarcharDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  event_code: fromDatatype.VarcharDatatypeInterface;
  guid: fromDatatype.GuidDataFieldInterface;
  guid_file: fromDatatype.GuidDataFieldInterface;
  hdr_guid: fromDatatype.GuidDataFieldInterface;
  line_guid: fromDatatype.GuidDataFieldInterface;
  membership_hdr_guid: fromDatatype.GuidDataFieldInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  namespace: fromDatatype.NamespaceDataFieldInterface;
  obj_action: fromDatatype.VarcharDatatypeInterface;
  payment_logic_json: fromDatatype.JsonDatatypeInterface;
  pricing_bundle_json: fromDatatype.JsonDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  redeemable_date_from: fromDatatype.TimestampTzDatatypeInterface;
  redeemable_date_to: fromDatatype.TimestampTzDatatypeInterface;
  redemption_status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  scan_event_guid: fromDatatype.GuidDataFieldInterface;
  serial_number: fromDatatype.VarcharDatatypeInterface;
  softpin: fromDatatype.VarcharDatatypeInterface;
  source: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  subject_guid: fromDatatype.GuidDataFieldInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  url_key: fromDatatype.VarcharDatatypeInterface;
  usage_json: fromDatatype.JsonDatatypeInterface;
  validity_status: fromDatatype.VarcharDatatypeInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}
